import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { mapParamsBySchema } from '../../../../util';
import { PPE_BASIC_03_Schema } from './PPE_BASIC_03_Schema';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapRowsBySchema } from '../../../../util';

/**
 * PPE_BASIC_03(보호구 지급대장) 관련 React Query 훅 모음
 */

// 지급대장 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess, context } = options;

  // queryKey에 context 정보 포함 (동적으로 업데이트됨)
  const queryKey = [
    'PPEManagement',
    'getPpeBasic03R1',
    context?.search?.custCd || '',
    context?.search?.currentYear || '',
  ];

  const query = useQuery({
    queryKey,
    queryFn: () => {
      // queryFn 내에서 최신 context로 params 생성
      const params = mapParamsBySchema(
        PPE_BASIC_03_Schema.mapper.search1,
        context
      );
      return apiRequest(
        'post',
        Global.urls.PPEManagement.getPpeBasic03R1,
        params
      );
    },
    enabled: false, // 자동 실행 방지
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt, query.data]);

  return query;
};

// 보호구 등록 조회
export const useSearch2 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(PPE_BASIC_03_Schema.mapper.search2);

  const query = useQuery({
    queryKey: ['PPEManagement', 'getPpeBasic01R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.PPEManagement.getPpeBasic01R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt, query.data]);

  return query;
};

/** 근로자별 보호구 저장 SaveEicBasicU1 (Global.urls.PPEManagement.saveEicBasicU1) */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PPE_BASIC_03_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.PPEManagement.saveEicBasicU1,
      payload
    );
  }, options);
};
